import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "tab-pane fade show active border border-top-0",
  id: "panel-pub-paper",
  role: "tabpanel",
  "aria-labelledby": "tab-pub-paper"
}
const _hoisted_2 = { class: "container p-3" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" をクリックするとBibTeXの情報が、 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" をクリックすると簡単なコメントが表示されます。 ")
const _hoisted_5 = { class: "list-group" }
const _hoisted_6 = { class: "list-group-item" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Preprint. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode(".) ")
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "btn-group btn-group-toggle" }
const _hoisted_19 = ["data-bs-target"]
const _hoisted_20 = ["data-bs-target", "aria-controls"]
const _hoisted_21 = ["id", "innerHTML"]
const _hoisted_22 = ["id", "aria-labelledby"]
const _hoisted_23 = { class: "modal-dialog modal-lg" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = { class: "modal-header" }
const _hoisted_26 = ["id"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_28 = { class: "modal-body" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Close")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['fa-solid', 'file-export'] }),
        _hoisted_3,
        _createVNode(_component_font_awesome_icon, { icon: ['fa-regular', 'comment-dots'] }),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.papers, (paper, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", {
                class: "mb-1",
                innerHTML: `[${_ctx.papers.length - index}] ${paper.title}`
              }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    class: "mb-0",
                    innerHTML: paper.author
                  }, null, 8, _hoisted_9),
                  _createElementVNode("p", _hoisted_10, [
                    (paper.hasOwnProperty('journal'))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("a", {
                            href: paper.url,
                            target: "_blank"
                          }, _toDisplayString(paper.journal) + " " + _toDisplayString(paper.volume) + ", " + _toDisplayString(paper.page) + " (" + _toDisplayString(paper.year) + ")", 9, _hoisted_11),
                          _hoisted_12
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_13
                        ], 64)),
                    _hoisted_14,
                    _createElementVNode("a", {
                      href: `https://arxiv.org/abs/${paper.arxiv}`,
                      target: "_blank"
                    }, "arXiv:" + _toDisplayString(paper.arxiv), 9, _hoisted_15),
                    _hoisted_16
                  ]),
                  (paper.hasOwnProperty('note'))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "mb-0",
                        innerHTML: paper.note
                      }, null, 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": `#pub-paper-${_ctx.papers.length - index}-bib`
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "big",
                      icon: ['fa-solid', 'file-export']
                    })
                  ], 8, _hoisted_19),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(paper.hasOwnProperty('comment') ? 'btn btn-outline-primary' : 'btn btn-outline-primary disabled'),
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#pub-paper-${_ctx.papers.length - index}`,
                    "aria-expanded": "false",
                    "aria-controls": `pub-paper-${_ctx.papers.length - index}`
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "big",
                      icon: ['fa-regular', 'comment-dots']
                    })
                  ], 10, _hoisted_20)
                ])
              ])
            ]),
            (paper.hasOwnProperty('comment'))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "list-group-item list-group-item-success collapse",
                  id: `pub-paper-${_ctx.papers.length - index}`,
                  innerHTML: paper.comment
                }, null, 8, _hoisted_21))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.papers, (paper, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "modal fade",
            id: `pub-paper-${_ctx.papers.length - index}-bib`,
            tabindex: "-1",
            "aria-labelledby": `pub-paper-${_ctx.papers.length - index}-bib-label`,
            "aria-hidden": "true"
          }, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("h5", {
                    class: "modal-title",
                    id: `pub-paper-${_ctx.papers.length - index}-bib-label`
                  }, "Get BibTeX", 8, _hoisted_26),
                  _hoisted_27
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("textarea", {
                    class: "form-control form-control-sm",
                    rows: "15",
                    readonly: "",
                    innerHTML: paper.bibtex
                  }, null, 8, _hoisted_29)
                ]),
                _hoisted_30
              ])
            ])
          ], 8, _hoisted_22))
        }), 128))
      ])
    ])
  ]))
}